/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/field/label/label_styles';



/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD : LABEL ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) =>
    <label className={`label ${props.classes.label}`}>{props.children}</label>
);
